export const MODULES = {
  MODULE_SIGN: 1,
  MODULE_PARKING: 3,
  MODULE_VMS: 5,
  MODULE_TCAM: 4,
  MODULE_DC: 6,
} as const;
